<template>
	<div class="body-content">
		<!-- <h1 class="content_title-main hidden">Главная</h1> -->

		<!-- <img
			class="body_image-postcard"
			src="https://res.cloudinary.com/ganir/image/upload/f_auto/v1671714155/gamma-press/home/000.new-year-2023.jpg"
			alt="new year postcard"
		/> -->
		<!-- <img class="body_image-postcard" src="https://res.cloudinary.com/ganir/image/upload/f_auto/v1703079356/gamma-press/home/000.new-year-2024.jpg" alt="postcard"> -->

		<!-- <img
			class="body_image-hero"
			src="https://res.cloudinary.com/ganir/image/upload/f_auto/v1613486050/gamma-press/home/002.home.png"
			alt="GAMMA-PRESS"
		/> -->

    <h1 class="content_title-main">Новости</h1>

    <div class="homepage-blog_wrapper">
      <div>
        <div :id="article.id" class="homepage-blog_article" v-for="article in articles" :key="article.id">
          <router-link :to="'/news/' + article.id" class="homepage-blog_link article_image-container" tag="div">
            <img class="homepage-blog_image" :class="{ medium: article.isMedium, wide: article.isWide }" :src="article.imagesrc" alt="IMAGE">
          </router-link>

          <div>
            <p class="body_text-plain" v-html="article.date"></p>

            <router-link :to="'/news/' + article.id" class="content_title-article" tag="h2">
              <span class="content_article_link" v-html="article.title"></span>
            </router-link>

            <p class="body_text-plain">
              <span v-html="article.content[0]"></span>
              <router-link :to="'/news/' + article.id" class="body_text-plain content_article_link" tag="span">
                (...)
              </router-link>
            </p>
          </div>
        </div>
      </div>

      <router-link to="/news" class="homepage-blog_news-link body_text-plain" tag="div">Все новости</router-link>
    </div>

		<h1 class="content_title-main">Об издательстве</h1>

		<div class="body_box">
			<p
				class="body_text-plain last"
			>Издательство «Гамма-Пресс» специализируется на выпуске книг широкой гуманитарной тематики — музыка, театр, изобразительное искусство, архитектура, история, мемуары. Отдельное направление — книги-альбомы, многие из которых высоко оценены специалистами. Триумфом стало успешное прохождение конкурсного отбора среди тысячи книг от двух сотен российских издательств и получение Гран-при на Национальном конкурсе «Книга года — 2012» за двухтомник, посвящённый 100-летию ГМИИ имени Пушкина. На конкурсе «Книга года — 2013» издательство получило диплом в номинации HUMANITAS за фундаментальный труд О. С. Поповой «Пути византийского искусства».</p>

			<p
				class="body_text-plain last"
			>Не меньший общественный резонанс вызвали такие издания, как «Борис Пастернак: Биографический альбом», «Шимон Перес: Биография», «В сердцевине ада: Записки, найденные в пепле возле печей Освенцима» З. Градовского, историческая монография «Итальянская Россия» Н. Эйдельмана и Ю. Крелина, монография А. Пильгуна «Потусторонний мир Средневековья: рай, чистилище, ад и их персонажи в визионерских текстах и миниатюрах из западноевропейских рукописей IX–XV веков», ставшей продолжением его же бестселлера «Вселенная Средневековья».</p>

			<p
				class="body_text-plain last"
			>Также «Гамма-Пресс» работает в сотрудничестве со старейшими российскими издательствами «Музыка» и «П. Юргенсон»: как совместные издания вышли в свет популярная сегодня книга М. А. Зильберквита «Мир музыки» и биографическая серия «Жизнь великих композиторов».</p>

			<p
				class="body_text-plain last"
			>Среди новинок ассортимента — мемуары грузинского кинорежиссёра и сценариста Л. Л. Гогоберидзе «Что вспоминается и как вспоминается…», а также — в развитие направления детской литературы — сборник М. Садовского «Я буду музыкантом: весёлые стихи с картинками для малышей».</p>
		</div>

		<h1 class="content_title-main">Сотрудничество</h1>

		<div class="body_box">
			<p
				class="body_text-plain last"
			>Издательство «Гамма-Пресс» приглашает к сотрудничеству партнёров, а также принимает к рассмотрению рукописи для выпуска на коммерческой основе в качестве заказных изданий.</p>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
  computed: {
    articles() {
      return this.$store.state.news.slice(0, 2);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";
</style>



// WEBPACK FOOTER //
// client/views/Home.vue